// last_agent: claude 2026-10-13 - the second-look reveal (his ruling 2026-10-13: the site's ONE signature motion).
// Elements with [data-ra-reveal] start slightly soft; on entering the viewport they get .is-ra-in and
// sharpen (CSS in snippets/ra-reveal.liquid), and a beat later .is-ra-settled drops the transition so
// the element's own transitions (hover etc.) are untouched afterwards. One-shot per element.
//
// Horizon's morph (filters, grid view) copies attributes from fresh server HTML, which would strip
// the classes and make a revealed card soft again; a MutationObserver puts them back at once
// (microtask, before paint, so nothing flickers) and picks up cards added by infinite scroll.

const SEL = '[data-ra-reveal]';
const IN = 'is-ra-in';
const SETTLED = 'is-ra-settled';
const root = document.documentElement;

const revealed = new WeakSet();
const watched = new WeakSet();

const ms = (el, name, fallback) => {
  const v = getComputedStyle(el).getPropertyValue(name).trim();
  if (!v) return fallback;
  const n = parseFloat(v);
  return Number.isNaN(n) ? fallback : v.endsWith('ms') ? n : n * 1000;
};

function settleLater(el) {
  // filter (dur) or the detail (beat + 700ms), whichever ends last, plus the stagger
  const delay = ms(el, '--ra-reveal-delay', 0);
  const total = delay + Math.max(ms(el, '--ra-reveal-dur', 850), ms(el, '--ra-reveal-beat', 420) + 700) + 60;
  window.setTimeout(() => el.classList.add(SETTLED), total);
}

const io = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      const el = entry.target;
      if (!entry.isIntersecting) {
        // already scrolled past (a restored scroll, a #card jump, a card re-rendered above the fold):
        // nobody watches it arrive, so show it as it is - no reveal playing behind the reader
        if (entry.boundingClientRect.bottom < 0) {
          io.unobserve(el);
          revealed.add(el);
          el.classList.add(IN, SETTLED);
        }
        continue;
      }
      io.unobserve(el);
      revealed.add(el);
      el.classList.add(IN);
      settleLater(el);
    }
  },
  { rootMargin: '0px 0px -10% 0px', threshold: 0 }
);

function watch(el) {
  if (watched.has(el)) return;
  watched.add(el);
  io.observe(el);
}

function scan(node) {
  if (!(node instanceof Element)) return;
  if (node.matches(SEL)) watch(node);
  node.querySelectorAll(SEL).forEach(watch);
}

const mo = new MutationObserver((records) => {
  for (const r of records) {
    if (r.type === 'childList') {
      r.addedNodes.forEach(scan);
    } else if (r.target instanceof Element && revealed.has(r.target)) {
      // morph stripped the state off a card that was already revealed: put it straight back
      if (!r.target.classList.contains(IN)) r.target.classList.add(IN, SETTLED);
    } else if (r.target instanceof Element && r.target.matches(SEL)) {
      watch(r.target);
    }
  }
});

function start() {
  if (!root.classList.contains('ra-reveal-on')) return; // reduced motion / no IO: end state already
  scan(document.body);
  mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'data-ra-reveal'] });
}

window.raReveal = { scan };

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
else start();
